import { t } from "@travily/i18n";
import { Icon } from "@ui/components/Icon";
import { IconActionLink } from "@ui/components/IconActionLink";

export interface MessagesActionProps {
  href: string;
  /** Number of unread messages. Renders a badge when greater than zero. */
  unreadCount?: number;
}

export function MessagesAction({ href, unreadCount = 0 }: MessagesActionProps) {
  const ariaLabel =
    unreadCount > 0
      ? t("components.views.shared.messages_action.unread_label", { count: unreadCount })
      : t("components.views.shared.messages_action.label");

  return (
    <IconActionLink ariaLabel={ariaLabel} badgeCount={unreadCount} href={href}>
      <Icon name="message" size="20" />
    </IconActionLink>
  );
}
